import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
    Container,
    Grid,
    Paper,
    MenuItem,
    CircularProgress
} from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { CustomModal } from 'Components/Modal/CustomModal';

import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { Action } from 'Pages/InnerPages/Enquiry/Action';
import { Select as ENQUIRY_SELECT } from 'Components/Api/EnquiryAPI';

import ReactTable from 'Components/ReactTable/ReactTable';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import Accordion from '@material-ui/core/Accordion';
import HOCAccordion from 'Components/CustomAccordion/HOCAccordion';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
const CustomAccordion = HOCAccordion(Accordion);
const CustomContainer = HOCLoader(Container);

export const EnquiryReport = () => {
    const formRef = useRef();
    const classes = commonStyle();
    const [itemList, setItemList] = useState([]);

    const [shouldGetUpdatedDataFromTable] = useState(false);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');

    const [responseMessage, setResponseMessage] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [openFilter, setopenFilter] = useState(true);
    const [enquiryDetailsID, setEnquiryDetailsID] = useState(0);

    const [ModelObj] = useState({
        ToDate: new Date(),
        FromDate: new Date(),
        Status: 'PENDING'
    });

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        var requestObj = JSON.stringify(values);

        setIsError(false);
        setLoadingOpen(true);

        setItemList([]);
        var response = await ENQUIRY_SELECT(requestObj);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }

        setSubmitting(false);
        var data = JSON.parse(response.data);

        setItemList(data);
    };

    const validationSchema = Yup.object({});

    const selectData = async () => {
        let jsonObj = {
            Status: 'PENDING'
        };
        var request = JSON.stringify(jsonObj);

        const response = await ENQUIRY_SELECT(request);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }
        var data = JSON.parse(response.data);
        setItemList(data);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'EnquiryDetailsID',
            srno: true
        });

        columns.push({
            label: 'Name',
            name: 'PersonName'
        });

        columns.push({
            label: 'Number',
            name: 'MobileNumber'
        });

        columns.push({
            label: 'Email',
            name: 'EmailID'
        });
        columns.push({
            label: 'EnquiryType',
            name: 'EnquiryType'
        });
        columns.push({
            label: 'Remark',
            name: 'Remark'
        });
        columns.push({
            label: 'Status',
            name: 'AdminStatus',
            customStatus: true
        });
        columns.push({
            label: 'Admin Remark',
            name: 'AdminRemark'
        });

        columns.push({
            label: 'Action',
            name: 'EnquiryDetailsID',
            disabledOn: ['COMPLETED'],
            statusIndex: 5,
            button: true,
            callback: (value) => {
                setIsOpen(true);
                setEnquiryDetailsID(value);
            }
        });

        setMainColumns(columns);
    };

    useEffect(() => {
        setLoadingOpen(true);
        createColumns();
        selectData();
    }, []);

    const refreshForm = () => {
        if (!formRef.current) return;

        formRef.current.handleSubmit();
    };
    const processUpdatedData = (newData) => {
        // setUpdatedItemList(newData);
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                initialValues={ModelObj}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                resetForm={ModelObj}
                render={({ values, setFieldValue, handleChange }) => {
                    return (
                        <Form style={{ marginBottom: '15px' }}>
                            <Grid item xs={12}>
                                <Paper>
                                    <CustomAccordion
                                        title={'Enquiry Report'}
                                        open={openFilter}
                                        setOpen={(value) =>
                                            setopenFilter(value)
                                        }
                                    >
                                        <Grid container spacing={2}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialSelect
                                                    label="Status"
                                                    name="Status"
                                                    title="Status"
                                                >
                                                    <MenuItem
                                                        key="ALL"
                                                        value="ALL"
                                                    >
                                                        All Status
                                                    </MenuItem>
                                                    <MenuItem
                                                        key="PENDING"
                                                        value="PENDING"
                                                    >
                                                        PENDING
                                                    </MenuItem>
                                                    <MenuItem
                                                        key="COMPLETED"
                                                        value="COMPLETED"
                                                    >
                                                        COMPLETED
                                                    </MenuItem>
                                                </MaterialSelect>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <PrimaryButton
                                                    type="submit"
                                                    title="submit"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loadingOpen}
                                                >
                                                    Search
                                                </PrimaryButton>
                                                {loadingOpen && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </Grid>
                                        </Grid>
                                    </CustomAccordion>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            />

            <ReactTable
                data={itemList}
                columns={mainColumns}
                getUpdatedData={processUpdatedData}
                shouldGetUpdatedData={shouldGetUpdatedDataFromTable}
            />
            {isOpen ? (
                <CustomModal
                    isOpen={isOpen}
                    title="Enquiry Action"
                    width="75%"
                    onDismissCallback={(value) => {
                        setIsOpen(value);
                        refreshForm();
                    }}
                >
                    <Action
                        EnquiryDetailsID={enquiryDetailsID}
                        onDismissCallback={(value) => {
                            setIsOpen(value);
                            refreshForm();
                        }}
                    />
                </CustomModal>
            ) : null}
        </CustomContainer>
    );
};
